import React from 'react';
import { CircleDashed } from 'lucide-react';

import { Head } from './parts';

export default function Placeholder({ title, section }) {
  return (
    <>
      <Head title={title} subtitle={section} />
      <div className="xo-coming-soon" role="status">
        <CircleDashed aria-hidden="true" />
        <span>Coming soon</span>
      </div>
    </>
  );
}
